import { render } from "./TaskHistory.vue?vue&type=template&id=e60bb5a8"
import script from "./TaskHistory.vue?vue&type=script&lang=js"
export * from "./TaskHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.21.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__